import { Component, ReactNode } from 'react';

// TODO: Consider adding error logger for catching FE errors
export class ErrorBoundary extends Component<Record<string, unknown>, { hasError: boolean }> {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError() {
        return { hasError: true };
    }

    render() {
        return this.state.hasError ? (this.props.errorComponent as ReactNode) : this.props.children;
    }
}
